import { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';

import SpaceY from '../../../../components/SpaceY';
import UImage from '../../../../components/UImage';
import { Recipe } from '../../../../type';
import { MAX_WIDTH_639PX } from '../../../../utils/common';
import { CommunityGtm } from '../../../../utils/gtm/community/communityGtm';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import RecipeCardOverlayTag from '../components/RecipeCardOverlayTag';
import VegetableList from '../VegetableList';

interface LatestRecipeCardProps {
  recipe: Recipe;
  thisWeekVegetables: string[];
}
const LatestRecipeCard = ({
  recipe,
  thisWeekVegetables,
}: LatestRecipeCardProps) => {
  const history = useHistoryMethod();
  const isMobile = useMediaQuery({ query: MAX_WIDTH_639PX });

  const [sortedIngredients, setSortedIngredients] = useState<string[]>([]);

  const handleClickRecipeCard = (recipe: Recipe) => {
    const communityGtm = new CommunityGtm();
    communityGtm.click_recipe({
      recipe_id: recipe.id.toString(),
      recipe_name: recipe.name,
      created_by: communityGtm.util.created_by({
        authorName: recipe.authorName,
      }),
    });
    history.push(`/recipes/${recipe.id}`);
  };

  useEffect(() => {
    let thisWeekIngredients: string[] = [];
    let notThisWeekIngredients: string[] = [];
    recipe.mainIngredient.forEach((ingredient) => {
      if (thisWeekVegetables.includes(ingredient.name)) {
        thisWeekIngredients.push(ingredient.name);
      } else {
        notThisWeekIngredients.push(ingredient.name);
      }
    });
    setSortedIngredients([...thisWeekIngredients, ...notThisWeekIngredients]);
  }, [recipe.mainIngredient, thisWeekVegetables]);

  return (
    <div
      onClick={() => handleClickRecipeCard(recipe)}
      onKeyDown={(e) => e.key === 'Enter' && handleClickRecipeCard(recipe)}
    >
      <div
        key={recipe.id}
        className="relative h-200px cursor-pointer overflow-hidden rounded-10px sm:h-240px"
      >
        <div className="absolute inset-0">
          <UImage
            src={recipe.images[0]}
            alt={recipe.name}
            width={240}
            height={240}
            className="h-full w-full object-cover object-center"
          />
        </div>
        <RecipeCardOverlayTag.Wrapper
          borderRadius="rounded-br-[10px]"
          position="left-0"
        >
          <RecipeCardOverlayTag.Bookmark recipe={recipe} iconSize={40} />
        </RecipeCardOverlayTag.Wrapper>
      </div>
      <SpaceY height={16} />
      <p className="text-18px font-bold">{recipe.name}</p>
      <SpaceY height={8} />
      <p className="text-14px font-medium text-gray-600">
        {recipe.recipeCreator?.name ?? recipe.authorName}
      </p>
      <SpaceY height={12} />
      <VegetableList
        left={!isMobile}
        names={sortedIngredients}
        thisWeekVegetables={thisWeekVegetables}
      />
    </div>
  );
};

export default LatestRecipeCard;
